import { EntityConfig } from 'angular-odata';

//#region ODataApi Imports
import { LeistungsprofilInternetverdachtHaendler } from './leistungsprofilinternetverdachthaendler.entity';
//#endregion

export const LeistungsprofilInternetverdachtHaendlerConfig = {
  name: "LeistungsprofilInternetverdachtHaendler",
  annotations: [],
  fields: {
    createdAt: {type: 'Edm.DateTimeOffset'},
    createdBy: {type: 'Edm.String'},
    changedAt: {type: 'Edm.DateTimeOffset'},
    changedBy: {type: 'Edm.String'},
    id: {type: 'Edm.Int32', key: true, ref: 'id', nullable: false}
  }
} as EntityConfig<LeistungsprofilInternetverdachtHaendler>;